import React from 'react';
import { Link } from 'react-router-dom';

function Navigation() {
  return (
    <nav style={{ backgroundColor: '#1a1a1a', padding: '1rem 0' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 20px',
        width: '100%'
      }}>
        <Link to="/" style={{ textDecoration: 'none', color: 'white' }}>
          <h1>Fangstoversikt</h1>
        </Link>
        <Link
          to="/favorites"
          style={{
            textDecoration: 'none',
            color: 'white',
            padding: '10px 15px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '4px',
            fontSize: '1rem',
            fontWeight: '500',
            transition: 'background-color 0.2s ease'
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLAnchorElement).style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLAnchorElement).style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
          }}
        >
          ★ Favoritter
        </Link>
      </div>
    </nav>
  );
}

export default Navigation;
